import { render, staticRenderFns } from "./GlobalComponents.vue?vue&type=template&id=6e669406"
import script from "./GlobalComponents.vue?vue&type=script&lang=js"
export * from "./GlobalComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports